import { Component, h, Prop, State, Element, Watch } from '@stencil/core';
import { getClassListString } from '../component-utils/stencilUtils';

type JournalArticleIcon = 'CME' | 'FREE' | 'Alg' | 'DDx' | 'PtEd' | 'POC' | 'Tool' | 'Key';

/**
 * COMPNAME is for displaying a list of icons for a journal article.
 */
@Component({
  tag: 'aafp-journal-article-icon-list',
  shadow: false,
})
export class AafpJournalArticleIconList {
  /**
   * A JSON array of icon string names, supported: CME, FREE, Alg, DDx, PtEd, POC, Tool, Key
   */
  @Prop() icons!: string;

  @State() iconsJson: Array<JournalArticleIcon> = [];

  @Element() element: HTMLElement;

  componentWillLoad() {
    this.parseIconsProp(this.icons);
  }

  @Watch('icons')
  parseIconsProp(newValue: string) {
    if (newValue) {
      this.iconsJson = JSON.parse(newValue);
    }
  }

  render() {
    return (
      <ul class="adl-journal-article-icon-list">
        {this.iconsJson.map((icon, index) => {
          return (
            <li
              class={getClassListString(
                { [`adl-journal-article-icon--${icon}`]: true },
                'adl-journal-article-icon',
                'adl-journal-article-icon-list__item',
              )}
              key={`${icon}-${index}`}
            >
              {icon}
            </li>
          );
        })}
      </ul>
    );
  }
}
